export const getContrastColor = (color) => {
    const tempElement = document.createElement("div");
    tempElement.style.color = color;
    document.body.appendChild(tempElement);
  
    let computedColor = window.getComputedStyle(tempElement).color;
    document.body.removeChild(tempElement);
  
    // Convert RGB to hex
    const rgbMatch = computedColor.match(/\d+/g);
    if (!rgbMatch || rgbMatch.length < 3) return "#000"; // Fallback
  
    let r = parseInt(rgbMatch[0], 10);
    let g = parseInt(rgbMatch[1], 10);
    let b = parseInt(rgbMatch[2], 10);
  
    // Use the official WCAG formula for luminance
    let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    let contrastColor = luminance > 0.5 ? "#000" : "#FFF"; // Black for light backgrounds, white for dark ones
  
    console.log(`BG: ${color} (${computedColor}), Luminance: ${luminance}, Text: ${contrastColor}`);
  
    return contrastColor;
  };
  